// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__hIGMY","active":"NavbarItem_active__d3OMy","dropdownMenu":"NavbarItem_dropdownMenu__RlD36","dropDownitems":"NavbarItem_dropDownitems__5IYcQ"};